import React from "react";
import {WizClassifySelect} from '@/containers/common';
import {component_tool} from '@/tool'

let {WizDataTable, WizButton} = component_tool

const columns = (self) => {
  return [
    {
      name: "id",
      formItem: {
        type: "hidden"
      }
    },
    {
      title: "语音模版",
      name: "code",
      dataIndex: "code",
      tableItem: {width: 220},
      searchItem: {},
    },
    {
      title: "语音内容",
      name: "content",
      dataIndex: "content",
      tableItem: {
        width: 500
      },
      searchItem: {}
    },

  ]
}

const tableApi = (api = {}) => {
  return {
    path: 'noticeTemplate/voiceMsgListByPage',
    ...api,
  }
}

const bankQuestion = (self, api) => {
  return {
    type: 'diy',
    title: '选择语音通知模版',
    initialValue: [],
    rowKey: 'code',
    rowName: 'code',
    columns: columns(self),
    tableApi: tableApi(api)
  }
}

export default bankQuestion
